import { connect } from 'react-redux';
import { TaskSummaryItem } from '.';

export default connect(state => state)(({ messages, task }) => (
  <div className="summary">
    <div className="info">
      <TaskSummaryItem
        label={messages.tasksNumberOfAnswers}
        value={task.answers ? task.answers.length : 0}
      />
      {task.unreviewedAnswers ? (
        <TaskSummaryItem
          category="danger"
          label={messages.tasksUnreviewed}
          value={task.unreviewedAnswers}
        />
      ) : null}
      <TaskSummaryItem
        label={messages.tasksAverageScore}
        value={task.averageScore || '–'}
      />
    </div>

    <style jsx>{`
      .info {
        margin-top: 15px;
      }
    `}</style>
  </div>
));
